/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AideRouteImport } from './routes/aide'
import { Route as CalculDateDeConceptionRouteImport } from './routes/calcul-date-de-conception'
import { Route as CalculOvulationRouteImport } from './routes/calcul-ovulation'
import { Route as CalculSemainesAmenorrheeRouteImport } from './routes/calcul-semaines-amenorrhee'
import { Route as CalendrierChinoisGrossesseRouteImport } from './routes/calendrier-chinois-grossesse'
import { Route as ConfidentialiteRouteImport } from './routes/confidentialite'
import { Route as DesabonnementRouteImport } from './routes/desabonnement'
import { Route as ExempleRouteImport } from './routes/exemple'
import { Route as GrossesseSemaineParSemaineRouteImport } from './routes/grossesse-semaine-par-semaine'
import { Route as IdeesCadeauxRouteImport } from './routes/idees-cadeaux'
import { Route as ListeAnniversaireRouteImport } from './routes/liste-anniversaire'
import { Route as ListeDeMariageRouteImport } from './routes/liste-de-mariage'
import { Route as ListeDeNaissanceRouteImport } from './routes/liste-de-naissance'
import { Route as ListeDeNoelRouteImport } from './routes/liste-de-noel'
import { Route as ListesEnGroupeRouteImport } from './routes/listes-en-groupe'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MentionsLegalesRouteImport } from './routes/mentions-legales'
import { Route as NouvelleListeRouteImport } from './routes/nouvelle-liste'
import { Route as SecretSantaRouteImport } from './routes/secret-santa'
import { Route as TendancesRouteImport } from './routes/tendances'
import { Route as AuthedAdminRouteImport } from './routes/_authed.admin'
import { Route as AuthedMonCompteRouteImport } from './routes/_authed.mon-compte'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as CalculDateAccouchementIndexRouteImport } from './routes/calcul-date-accouchement.index'
import { Route as CalculDateAccouchementMethodRouteImport } from './routes/calcul-date-accouchement.$method'
import { Route as ComparatifIndexRouteImport } from './routes/comparatif.index'
import { Route as ComparatifSlugRouteImport } from './routes/comparatif.$slug'
import { Route as GSlugRouteImport } from './routes/g.$slug'
import { Route as GroupesNouveauRouteImport } from './routes/groupes.nouveau'
import { Route as IdeesCadeauxNaissanceIndexRouteImport } from './routes/idees-cadeaux-naissance.index'
import { Route as IdeesCadeauxNaissanceCategoryRouteImport } from './routes/idees-cadeaux-naissance.$category'
import { Route as InvitationsListRouteImport } from './routes/invitations.list'
import { Route as LSlugRouteImport } from './routes/l.$slug'
import { Route as LoginVerifyRouteImport } from './routes/login_.verify'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as PrenomsIndexRouteImport } from './routes/prenoms.index'
import { Route as PrenomsSlugRouteImport } from './routes/prenoms.$slug'
import { Route as PrenomsTendancesRouteImport } from './routes/prenoms.tendances'
import { Route as SecretSantaNouveauRouteImport } from './routes/secret-santa_.nouveau'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed.admin.index'
import { Route as AuthedAdminConsoRouteImport } from './routes/_authed.admin.conso'
import { Route as AuthedAdminCroissanceRouteImport } from './routes/_authed.admin.croissance'
import { Route as AuthedAdminDesignsRouteImport } from './routes/_authed.admin.designs'
import { Route as AuthedAdminListesRouteImport } from './routes/_authed.admin.listes'
import { Route as AuthedAdminProduitsRouteImport } from './routes/_authed.admin.produits'
import { Route as AuthedAdminSystemeRouteImport } from './routes/_authed.admin.systeme'
import { Route as AuthedMesGroupesGroupIdRouteImport } from './routes/_authed.mes-groupes.$groupId'
import { Route as AuthedMesListesIndexRouteImport } from './routes/_authed.mes-listes.index'
import { Route as AuthedMesListesListIdRouteImport } from './routes/_authed.mes-listes.$listId'
import { Route as MesListesListIdPreviewRouteImport } from './routes/mes-listes.$listId.preview'
import { Route as PrenomsAnneeIndexRouteImport } from './routes/prenoms.annee.index'
import { Route as PrenomsDepartementIndexRouteImport } from './routes/prenoms.departement.index'
import { Route as PrenomsDepartementDepartmentRouteImport } from './routes/prenoms.departement.$department'
import { Route as AuthedAdminSitesIndexRouteImport } from './routes/_authed.admin.sites.index'
import { Route as AuthedAdminSitesHostRouteImport } from './routes/_authed.admin.sites.$host'
import { Route as PrenomsAnneeYearIndexRouteImport } from './routes/prenoms.annee.$year.index'
import { Route as PrenomsAnneeYearDepartmentRouteImport } from './routes/prenoms.annee.$year.$department'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AideRoute = AideRouteImport.update({
  id: '/aide',
  path: '/aide',
  getParentRoute: () => rootRouteImport,
} as any)
const CalculDateDeConceptionRoute = CalculDateDeConceptionRouteImport.update({
  id: '/calcul-date-de-conception',
  path: '/calcul-date-de-conception',
  getParentRoute: () => rootRouteImport,
} as any)
const CalculOvulationRoute = CalculOvulationRouteImport.update({
  id: '/calcul-ovulation',
  path: '/calcul-ovulation',
  getParentRoute: () => rootRouteImport,
} as any)
const CalculSemainesAmenorrheeRoute =
  CalculSemainesAmenorrheeRouteImport.update({
    id: '/calcul-semaines-amenorrhee',
    path: '/calcul-semaines-amenorrhee',
    getParentRoute: () => rootRouteImport,
  } as any)
const CalendrierChinoisGrossesseRoute =
  CalendrierChinoisGrossesseRouteImport.update({
    id: '/calendrier-chinois-grossesse',
    path: '/calendrier-chinois-grossesse',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConfidentialiteRoute = ConfidentialiteRouteImport.update({
  id: '/confidentialite',
  path: '/confidentialite',
  getParentRoute: () => rootRouteImport,
} as any)
const DesabonnementRoute = DesabonnementRouteImport.update({
  id: '/desabonnement',
  path: '/desabonnement',
  getParentRoute: () => rootRouteImport,
} as any)
const ExempleRoute = ExempleRouteImport.update({
  id: '/exemple',
  path: '/exemple',
  getParentRoute: () => rootRouteImport,
} as any)
const GrossesseSemaineParSemaineRoute =
  GrossesseSemaineParSemaineRouteImport.update({
    id: '/grossesse-semaine-par-semaine',
    path: '/grossesse-semaine-par-semaine',
    getParentRoute: () => rootRouteImport,
  } as any)
const IdeesCadeauxRoute = IdeesCadeauxRouteImport.update({
  id: '/idees-cadeaux',
  path: '/idees-cadeaux',
  getParentRoute: () => rootRouteImport,
} as any)
const ListeAnniversaireRoute = ListeAnniversaireRouteImport.update({
  id: '/liste-anniversaire',
  path: '/liste-anniversaire',
  getParentRoute: () => rootRouteImport,
} as any)
const ListeDeMariageRoute = ListeDeMariageRouteImport.update({
  id: '/liste-de-mariage',
  path: '/liste-de-mariage',
  getParentRoute: () => rootRouteImport,
} as any)
const ListeDeNaissanceRoute = ListeDeNaissanceRouteImport.update({
  id: '/liste-de-naissance',
  path: '/liste-de-naissance',
  getParentRoute: () => rootRouteImport,
} as any)
const ListeDeNoelRoute = ListeDeNoelRouteImport.update({
  id: '/liste-de-noel',
  path: '/liste-de-noel',
  getParentRoute: () => rootRouteImport,
} as any)
const ListesEnGroupeRoute = ListesEnGroupeRouteImport.update({
  id: '/listes-en-groupe',
  path: '/listes-en-groupe',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MentionsLegalesRoute = MentionsLegalesRouteImport.update({
  id: '/mentions-legales',
  path: '/mentions-legales',
  getParentRoute: () => rootRouteImport,
} as any)
const NouvelleListeRoute = NouvelleListeRouteImport.update({
  id: '/nouvelle-liste',
  path: '/nouvelle-liste',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretSantaRoute = SecretSantaRouteImport.update({
  id: '/secret-santa',
  path: '/secret-santa',
  getParentRoute: () => rootRouteImport,
} as any)
const TendancesRoute = TendancesRouteImport.update({
  id: '/tendances',
  path: '/tendances',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMonCompteRoute = AuthedMonCompteRouteImport.update({
  id: '/mon-compte',
  path: '/mon-compte',
  getParentRoute: () => AuthedRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CalculDateAccouchementIndexRoute =
  CalculDateAccouchementIndexRouteImport.update({
    id: '/calcul-date-accouchement/',
    path: '/calcul-date-accouchement/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CalculDateAccouchementMethodRoute =
  CalculDateAccouchementMethodRouteImport.update({
    id: '/calcul-date-accouchement/$method',
    path: '/calcul-date-accouchement/$method',
    getParentRoute: () => rootRouteImport,
  } as any)
const ComparatifIndexRoute = ComparatifIndexRouteImport.update({
  id: '/comparatif/',
  path: '/comparatif/',
  getParentRoute: () => rootRouteImport,
} as any)
const ComparatifSlugRoute = ComparatifSlugRouteImport.update({
  id: '/comparatif/$slug',
  path: '/comparatif/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const GSlugRoute = GSlugRouteImport.update({
  id: '/g/$slug',
  path: '/g/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const GroupesNouveauRoute = GroupesNouveauRouteImport.update({
  id: '/groupes/nouveau',
  path: '/groupes/nouveau',
  getParentRoute: () => rootRouteImport,
} as any)
const IdeesCadeauxNaissanceIndexRoute =
  IdeesCadeauxNaissanceIndexRouteImport.update({
    id: '/idees-cadeaux-naissance/',
    path: '/idees-cadeaux-naissance/',
    getParentRoute: () => rootRouteImport,
  } as any)
const IdeesCadeauxNaissanceCategoryRoute =
  IdeesCadeauxNaissanceCategoryRouteImport.update({
    id: '/idees-cadeaux-naissance/$category',
    path: '/idees-cadeaux-naissance/$category',
    getParentRoute: () => rootRouteImport,
  } as any)
const InvitationsListRoute = InvitationsListRouteImport.update({
  id: '/invitations/list',
  path: '/invitations/list',
  getParentRoute: () => rootRouteImport,
} as any)
const LSlugRoute = LSlugRouteImport.update({
  id: '/l/$slug',
  path: '/l/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginVerifyRoute = LoginVerifyRouteImport.update({
  id: '/login_/verify',
  path: '/login/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsIndexRoute = PrenomsIndexRouteImport.update({
  id: '/prenoms/',
  path: '/prenoms/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsSlugRoute = PrenomsSlugRouteImport.update({
  id: '/prenoms/$slug',
  path: '/prenoms/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsTendancesRoute = PrenomsTendancesRouteImport.update({
  id: '/prenoms/tendances',
  path: '/prenoms/tendances',
  getParentRoute: () => rootRouteImport,
} as any)
const SecretSantaNouveauRoute = SecretSantaNouveauRouteImport.update({
  id: '/secret-santa_/nouveau',
  path: '/secret-santa/nouveau',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminConsoRoute = AuthedAdminConsoRouteImport.update({
  id: '/conso',
  path: '/conso',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminCroissanceRoute = AuthedAdminCroissanceRouteImport.update({
  id: '/croissance',
  path: '/croissance',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminDesignsRoute = AuthedAdminDesignsRouteImport.update({
  id: '/designs',
  path: '/designs',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminListesRoute = AuthedAdminListesRouteImport.update({
  id: '/listes',
  path: '/listes',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminProduitsRoute = AuthedAdminProduitsRouteImport.update({
  id: '/produits',
  path: '/produits',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminSystemeRoute = AuthedAdminSystemeRouteImport.update({
  id: '/systeme',
  path: '/systeme',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedMesGroupesGroupIdRoute = AuthedMesGroupesGroupIdRouteImport.update({
  id: '/mes-groupes/$groupId',
  path: '/mes-groupes/$groupId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMesListesIndexRoute = AuthedMesListesIndexRouteImport.update({
  id: '/mes-listes/',
  path: '/mes-listes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMesListesListIdRoute = AuthedMesListesListIdRouteImport.update({
  id: '/mes-listes/$listId',
  path: '/mes-listes/$listId',
  getParentRoute: () => AuthedRoute,
} as any)
const MesListesListIdPreviewRoute = MesListesListIdPreviewRouteImport.update({
  id: '/mes-listes/$listId/preview',
  path: '/mes-listes/$listId/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsAnneeIndexRoute = PrenomsAnneeIndexRouteImport.update({
  id: '/prenoms/annee/',
  path: '/prenoms/annee/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsDepartementIndexRoute = PrenomsDepartementIndexRouteImport.update({
  id: '/prenoms/departement/',
  path: '/prenoms/departement/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsDepartementDepartmentRoute =
  PrenomsDepartementDepartmentRouteImport.update({
    id: '/prenoms/departement/$department',
    path: '/prenoms/departement/$department',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthedAdminSitesIndexRoute = AuthedAdminSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const AuthedAdminSitesHostRoute = AuthedAdminSitesHostRouteImport.update({
  id: '/sites/$host',
  path: '/sites/$host',
  getParentRoute: () => AuthedAdminRoute,
} as any)
const PrenomsAnneeYearIndexRoute = PrenomsAnneeYearIndexRouteImport.update({
  id: '/prenoms/annee/$year/',
  path: '/prenoms/annee/$year/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrenomsAnneeYearDepartmentRoute =
  PrenomsAnneeYearDepartmentRouteImport.update({
    id: '/prenoms/annee/$year/$department',
    path: '/prenoms/annee/$year/$department',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aide': typeof AideRoute
  '/calcul-date-de-conception': typeof CalculDateDeConceptionRoute
  '/calcul-ovulation': typeof CalculOvulationRoute
  '/calcul-semaines-amenorrhee': typeof CalculSemainesAmenorrheeRoute
  '/calendrier-chinois-grossesse': typeof CalendrierChinoisGrossesseRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/desabonnement': typeof DesabonnementRoute
  '/exemple': typeof ExempleRoute
  '/grossesse-semaine-par-semaine': typeof GrossesseSemaineParSemaineRoute
  '/idees-cadeaux': typeof IdeesCadeauxRoute
  '/liste-anniversaire': typeof ListeAnniversaireRoute
  '/liste-de-mariage': typeof ListeDeMariageRoute
  '/liste-de-naissance': typeof ListeDeNaissanceRoute
  '/liste-de-noel': typeof ListeDeNoelRoute
  '/listes-en-groupe': typeof ListesEnGroupeRoute
  '/login': typeof LoginRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/nouvelle-liste': typeof NouvelleListeRoute
  '/secret-santa': typeof SecretSantaRoute
  '/tendances': typeof TendancesRoute
  '/admin': typeof AuthedAdminRouteWithChildren
  '/mon-compte': typeof AuthedMonCompteRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/calcul-date-accouchement/$method': typeof CalculDateAccouchementMethodRoute
  '/comparatif/$slug': typeof ComparatifSlugRoute
  '/g/$slug': typeof GSlugRoute
  '/groupes/nouveau': typeof GroupesNouveauRoute
  '/idees-cadeaux-naissance/$category': typeof IdeesCadeauxNaissanceCategoryRoute
  '/invitations/list': typeof InvitationsListRoute
  '/l/$slug': typeof LSlugRoute
  '/login/verify': typeof LoginVerifyRoute
  '/p/$slug': typeof PSlugRoute
  '/prenoms/$slug': typeof PrenomsSlugRoute
  '/prenoms/tendances': typeof PrenomsTendancesRoute
  '/secret-santa/nouveau': typeof SecretSantaNouveauRoute
  '/blog/': typeof BlogIndexRoute
  '/calcul-date-accouchement/': typeof CalculDateAccouchementIndexRoute
  '/comparatif/': typeof ComparatifIndexRoute
  '/idees-cadeaux-naissance/': typeof IdeesCadeauxNaissanceIndexRoute
  '/prenoms/': typeof PrenomsIndexRoute
  '/admin/conso': typeof AuthedAdminConsoRoute
  '/admin/croissance': typeof AuthedAdminCroissanceRoute
  '/admin/designs': typeof AuthedAdminDesignsRoute
  '/admin/listes': typeof AuthedAdminListesRoute
  '/admin/produits': typeof AuthedAdminProduitsRoute
  '/admin/systeme': typeof AuthedAdminSystemeRoute
  '/mes-groupes/$groupId': typeof AuthedMesGroupesGroupIdRoute
  '/mes-listes/$listId': typeof AuthedMesListesListIdRoute
  '/mes-listes/$listId/preview': typeof MesListesListIdPreviewRoute
  '/prenoms/departement/$department': typeof PrenomsDepartementDepartmentRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/mes-listes/': typeof AuthedMesListesIndexRoute
  '/prenoms/annee/': typeof PrenomsAnneeIndexRoute
  '/prenoms/departement/': typeof PrenomsDepartementIndexRoute
  '/admin/sites/$host': typeof AuthedAdminSitesHostRoute
  '/prenoms/annee/$year/$department': typeof PrenomsAnneeYearDepartmentRoute
  '/admin/sites/': typeof AuthedAdminSitesIndexRoute
  '/prenoms/annee/$year/': typeof PrenomsAnneeYearIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aide': typeof AideRoute
  '/calcul-date-de-conception': typeof CalculDateDeConceptionRoute
  '/calcul-ovulation': typeof CalculOvulationRoute
  '/calcul-semaines-amenorrhee': typeof CalculSemainesAmenorrheeRoute
  '/calendrier-chinois-grossesse': typeof CalendrierChinoisGrossesseRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/desabonnement': typeof DesabonnementRoute
  '/exemple': typeof ExempleRoute
  '/grossesse-semaine-par-semaine': typeof GrossesseSemaineParSemaineRoute
  '/idees-cadeaux': typeof IdeesCadeauxRoute
  '/liste-anniversaire': typeof ListeAnniversaireRoute
  '/liste-de-mariage': typeof ListeDeMariageRoute
  '/liste-de-naissance': typeof ListeDeNaissanceRoute
  '/liste-de-noel': typeof ListeDeNoelRoute
  '/listes-en-groupe': typeof ListesEnGroupeRoute
  '/login': typeof LoginRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/nouvelle-liste': typeof NouvelleListeRoute
  '/secret-santa': typeof SecretSantaRoute
  '/tendances': typeof TendancesRoute
  '/mon-compte': typeof AuthedMonCompteRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/calcul-date-accouchement/$method': typeof CalculDateAccouchementMethodRoute
  '/comparatif/$slug': typeof ComparatifSlugRoute
  '/g/$slug': typeof GSlugRoute
  '/groupes/nouveau': typeof GroupesNouveauRoute
  '/idees-cadeaux-naissance/$category': typeof IdeesCadeauxNaissanceCategoryRoute
  '/invitations/list': typeof InvitationsListRoute
  '/l/$slug': typeof LSlugRoute
  '/login/verify': typeof LoginVerifyRoute
  '/p/$slug': typeof PSlugRoute
  '/prenoms/$slug': typeof PrenomsSlugRoute
  '/prenoms/tendances': typeof PrenomsTendancesRoute
  '/secret-santa/nouveau': typeof SecretSantaNouveauRoute
  '/blog': typeof BlogIndexRoute
  '/calcul-date-accouchement': typeof CalculDateAccouchementIndexRoute
  '/comparatif': typeof ComparatifIndexRoute
  '/idees-cadeaux-naissance': typeof IdeesCadeauxNaissanceIndexRoute
  '/prenoms': typeof PrenomsIndexRoute
  '/admin/conso': typeof AuthedAdminConsoRoute
  '/admin/croissance': typeof AuthedAdminCroissanceRoute
  '/admin/designs': typeof AuthedAdminDesignsRoute
  '/admin/listes': typeof AuthedAdminListesRoute
  '/admin/produits': typeof AuthedAdminProduitsRoute
  '/admin/systeme': typeof AuthedAdminSystemeRoute
  '/mes-groupes/$groupId': typeof AuthedMesGroupesGroupIdRoute
  '/mes-listes/$listId': typeof AuthedMesListesListIdRoute
  '/mes-listes/$listId/preview': typeof MesListesListIdPreviewRoute
  '/prenoms/departement/$department': typeof PrenomsDepartementDepartmentRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/mes-listes': typeof AuthedMesListesIndexRoute
  '/prenoms/annee': typeof PrenomsAnneeIndexRoute
  '/prenoms/departement': typeof PrenomsDepartementIndexRoute
  '/admin/sites/$host': typeof AuthedAdminSitesHostRoute
  '/prenoms/annee/$year/$department': typeof PrenomsAnneeYearDepartmentRoute
  '/admin/sites': typeof AuthedAdminSitesIndexRoute
  '/prenoms/annee/$year': typeof PrenomsAnneeYearIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/aide': typeof AideRoute
  '/calcul-date-de-conception': typeof CalculDateDeConceptionRoute
  '/calcul-ovulation': typeof CalculOvulationRoute
  '/calcul-semaines-amenorrhee': typeof CalculSemainesAmenorrheeRoute
  '/calendrier-chinois-grossesse': typeof CalendrierChinoisGrossesseRoute
  '/confidentialite': typeof ConfidentialiteRoute
  '/desabonnement': typeof DesabonnementRoute
  '/exemple': typeof ExempleRoute
  '/grossesse-semaine-par-semaine': typeof GrossesseSemaineParSemaineRoute
  '/idees-cadeaux': typeof IdeesCadeauxRoute
  '/liste-anniversaire': typeof ListeAnniversaireRoute
  '/liste-de-mariage': typeof ListeDeMariageRoute
  '/liste-de-naissance': typeof ListeDeNaissanceRoute
  '/liste-de-noel': typeof ListeDeNoelRoute
  '/listes-en-groupe': typeof ListesEnGroupeRoute
  '/login': typeof LoginRoute
  '/mentions-legales': typeof MentionsLegalesRoute
  '/nouvelle-liste': typeof NouvelleListeRoute
  '/secret-santa': typeof SecretSantaRoute
  '/tendances': typeof TendancesRoute
  '/_authed/admin': typeof AuthedAdminRouteWithChildren
  '/_authed/mon-compte': typeof AuthedMonCompteRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/calcul-date-accouchement/$method': typeof CalculDateAccouchementMethodRoute
  '/comparatif/$slug': typeof ComparatifSlugRoute
  '/g/$slug': typeof GSlugRoute
  '/groupes/nouveau': typeof GroupesNouveauRoute
  '/idees-cadeaux-naissance/$category': typeof IdeesCadeauxNaissanceCategoryRoute
  '/invitations/list': typeof InvitationsListRoute
  '/l/$slug': typeof LSlugRoute
  '/login_/verify': typeof LoginVerifyRoute
  '/p/$slug': typeof PSlugRoute
  '/prenoms/$slug': typeof PrenomsSlugRoute
  '/prenoms/tendances': typeof PrenomsTendancesRoute
  '/secret-santa_/nouveau': typeof SecretSantaNouveauRoute
  '/blog/': typeof BlogIndexRoute
  '/calcul-date-accouchement/': typeof CalculDateAccouchementIndexRoute
  '/comparatif/': typeof ComparatifIndexRoute
  '/idees-cadeaux-naissance/': typeof IdeesCadeauxNaissanceIndexRoute
  '/prenoms/': typeof PrenomsIndexRoute
  '/_authed/admin/conso': typeof AuthedAdminConsoRoute
  '/_authed/admin/croissance': typeof AuthedAdminCroissanceRoute
  '/_authed/admin/designs': typeof AuthedAdminDesignsRoute
  '/_authed/admin/listes': typeof AuthedAdminListesRoute
  '/_authed/admin/produits': typeof AuthedAdminProduitsRoute
  '/_authed/admin/systeme': typeof AuthedAdminSystemeRoute
  '/_authed/mes-groupes/$groupId': typeof AuthedMesGroupesGroupIdRoute
  '/_authed/mes-listes/$listId': typeof AuthedMesListesListIdRoute
  '/mes-listes/$listId/preview': typeof MesListesListIdPreviewRoute
  '/prenoms/departement/$department': typeof PrenomsDepartementDepartmentRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/mes-listes/': typeof AuthedMesListesIndexRoute
  '/prenoms/annee/': typeof PrenomsAnneeIndexRoute
  '/prenoms/departement/': typeof PrenomsDepartementIndexRoute
  '/_authed/admin/sites/$host': typeof AuthedAdminSitesHostRoute
  '/prenoms/annee/$year/$department': typeof PrenomsAnneeYearDepartmentRoute
  '/_authed/admin/sites/': typeof AuthedAdminSitesIndexRoute
  '/prenoms/annee/$year/': typeof PrenomsAnneeYearIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aide'
    | '/calcul-date-de-conception'
    | '/calcul-ovulation'
    | '/calcul-semaines-amenorrhee'
    | '/calendrier-chinois-grossesse'
    | '/confidentialite'
    | '/desabonnement'
    | '/exemple'
    | '/grossesse-semaine-par-semaine'
    | '/idees-cadeaux'
    | '/liste-anniversaire'
    | '/liste-de-mariage'
    | '/liste-de-naissance'
    | '/liste-de-noel'
    | '/listes-en-groupe'
    | '/login'
    | '/mentions-legales'
    | '/nouvelle-liste'
    | '/secret-santa'
    | '/tendances'
    | '/admin'
    | '/mon-compte'
    | '/blog/$slug'
    | '/calcul-date-accouchement/$method'
    | '/comparatif/$slug'
    | '/g/$slug'
    | '/groupes/nouveau'
    | '/idees-cadeaux-naissance/$category'
    | '/invitations/list'
    | '/l/$slug'
    | '/login/verify'
    | '/p/$slug'
    | '/prenoms/$slug'
    | '/prenoms/tendances'
    | '/secret-santa/nouveau'
    | '/blog/'
    | '/calcul-date-accouchement/'
    | '/comparatif/'
    | '/idees-cadeaux-naissance/'
    | '/prenoms/'
    | '/admin/conso'
    | '/admin/croissance'
    | '/admin/designs'
    | '/admin/listes'
    | '/admin/produits'
    | '/admin/systeme'
    | '/mes-groupes/$groupId'
    | '/mes-listes/$listId'
    | '/mes-listes/$listId/preview'
    | '/prenoms/departement/$department'
    | '/admin/'
    | '/mes-listes/'
    | '/prenoms/annee/'
    | '/prenoms/departement/'
    | '/admin/sites/$host'
    | '/prenoms/annee/$year/$department'
    | '/admin/sites/'
    | '/prenoms/annee/$year/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aide'
    | '/calcul-date-de-conception'
    | '/calcul-ovulation'
    | '/calcul-semaines-amenorrhee'
    | '/calendrier-chinois-grossesse'
    | '/confidentialite'
    | '/desabonnement'
    | '/exemple'
    | '/grossesse-semaine-par-semaine'
    | '/idees-cadeaux'
    | '/liste-anniversaire'
    | '/liste-de-mariage'
    | '/liste-de-naissance'
    | '/liste-de-noel'
    | '/listes-en-groupe'
    | '/login'
    | '/mentions-legales'
    | '/nouvelle-liste'
    | '/secret-santa'
    | '/tendances'
    | '/mon-compte'
    | '/blog/$slug'
    | '/calcul-date-accouchement/$method'
    | '/comparatif/$slug'
    | '/g/$slug'
    | '/groupes/nouveau'
    | '/idees-cadeaux-naissance/$category'
    | '/invitations/list'
    | '/l/$slug'
    | '/login/verify'
    | '/p/$slug'
    | '/prenoms/$slug'
    | '/prenoms/tendances'
    | '/secret-santa/nouveau'
    | '/blog'
    | '/calcul-date-accouchement'
    | '/comparatif'
    | '/idees-cadeaux-naissance'
    | '/prenoms'
    | '/admin/conso'
    | '/admin/croissance'
    | '/admin/designs'
    | '/admin/listes'
    | '/admin/produits'
    | '/admin/systeme'
    | '/mes-groupes/$groupId'
    | '/mes-listes/$listId'
    | '/mes-listes/$listId/preview'
    | '/prenoms/departement/$department'
    | '/admin'
    | '/mes-listes'
    | '/prenoms/annee'
    | '/prenoms/departement'
    | '/admin/sites/$host'
    | '/prenoms/annee/$year/$department'
    | '/admin/sites'
    | '/prenoms/annee/$year'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/aide'
    | '/calcul-date-de-conception'
    | '/calcul-ovulation'
    | '/calcul-semaines-amenorrhee'
    | '/calendrier-chinois-grossesse'
    | '/confidentialite'
    | '/desabonnement'
    | '/exemple'
    | '/grossesse-semaine-par-semaine'
    | '/idees-cadeaux'
    | '/liste-anniversaire'
    | '/liste-de-mariage'
    | '/liste-de-naissance'
    | '/liste-de-noel'
    | '/listes-en-groupe'
    | '/login'
    | '/mentions-legales'
    | '/nouvelle-liste'
    | '/secret-santa'
    | '/tendances'
    | '/_authed/admin'
    | '/_authed/mon-compte'
    | '/blog/$slug'
    | '/calcul-date-accouchement/$method'
    | '/comparatif/$slug'
    | '/g/$slug'
    | '/groupes/nouveau'
    | '/idees-cadeaux-naissance/$category'
    | '/invitations/list'
    | '/l/$slug'
    | '/login_/verify'
    | '/p/$slug'
    | '/prenoms/$slug'
    | '/prenoms/tendances'
    | '/secret-santa_/nouveau'
    | '/blog/'
    | '/calcul-date-accouchement/'
    | '/comparatif/'
    | '/idees-cadeaux-naissance/'
    | '/prenoms/'
    | '/_authed/admin/conso'
    | '/_authed/admin/croissance'
    | '/_authed/admin/designs'
    | '/_authed/admin/listes'
    | '/_authed/admin/produits'
    | '/_authed/admin/systeme'
    | '/_authed/mes-groupes/$groupId'
    | '/_authed/mes-listes/$listId'
    | '/mes-listes/$listId/preview'
    | '/prenoms/departement/$department'
    | '/_authed/admin/'
    | '/_authed/mes-listes/'
    | '/prenoms/annee/'
    | '/prenoms/departement/'
    | '/_authed/admin/sites/$host'
    | '/prenoms/annee/$year/$department'
    | '/_authed/admin/sites/'
    | '/prenoms/annee/$year/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  AideRoute: typeof AideRoute
  CalculDateDeConceptionRoute: typeof CalculDateDeConceptionRoute
  CalculOvulationRoute: typeof CalculOvulationRoute
  CalculSemainesAmenorrheeRoute: typeof CalculSemainesAmenorrheeRoute
  CalendrierChinoisGrossesseRoute: typeof CalendrierChinoisGrossesseRoute
  ConfidentialiteRoute: typeof ConfidentialiteRoute
  DesabonnementRoute: typeof DesabonnementRoute
  ExempleRoute: typeof ExempleRoute
  GrossesseSemaineParSemaineRoute: typeof GrossesseSemaineParSemaineRoute
  IdeesCadeauxRoute: typeof IdeesCadeauxRoute
  ListeAnniversaireRoute: typeof ListeAnniversaireRoute
  ListeDeMariageRoute: typeof ListeDeMariageRoute
  ListeDeNaissanceRoute: typeof ListeDeNaissanceRoute
  ListeDeNoelRoute: typeof ListeDeNoelRoute
  ListesEnGroupeRoute: typeof ListesEnGroupeRoute
  LoginRoute: typeof LoginRoute
  MentionsLegalesRoute: typeof MentionsLegalesRoute
  NouvelleListeRoute: typeof NouvelleListeRoute
  SecretSantaRoute: typeof SecretSantaRoute
  TendancesRoute: typeof TendancesRoute
  BlogSlugRoute: typeof BlogSlugRoute
  CalculDateAccouchementMethodRoute: typeof CalculDateAccouchementMethodRoute
  ComparatifSlugRoute: typeof ComparatifSlugRoute
  GSlugRoute: typeof GSlugRoute
  GroupesNouveauRoute: typeof GroupesNouveauRoute
  IdeesCadeauxNaissanceCategoryRoute: typeof IdeesCadeauxNaissanceCategoryRoute
  InvitationsListRoute: typeof InvitationsListRoute
  LSlugRoute: typeof LSlugRoute
  LoginVerifyRoute: typeof LoginVerifyRoute
  PSlugRoute: typeof PSlugRoute
  PrenomsSlugRoute: typeof PrenomsSlugRoute
  PrenomsTendancesRoute: typeof PrenomsTendancesRoute
  SecretSantaNouveauRoute: typeof SecretSantaNouveauRoute
  BlogIndexRoute: typeof BlogIndexRoute
  CalculDateAccouchementIndexRoute: typeof CalculDateAccouchementIndexRoute
  ComparatifIndexRoute: typeof ComparatifIndexRoute
  IdeesCadeauxNaissanceIndexRoute: typeof IdeesCadeauxNaissanceIndexRoute
  PrenomsIndexRoute: typeof PrenomsIndexRoute
  MesListesListIdPreviewRoute: typeof MesListesListIdPreviewRoute
  PrenomsDepartementDepartmentRoute: typeof PrenomsDepartementDepartmentRoute
  PrenomsAnneeIndexRoute: typeof PrenomsAnneeIndexRoute
  PrenomsDepartementIndexRoute: typeof PrenomsDepartementIndexRoute
  PrenomsAnneeYearDepartmentRoute: typeof PrenomsAnneeYearDepartmentRoute
  PrenomsAnneeYearIndexRoute: typeof PrenomsAnneeYearIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aide': {
      id: '/aide'
      path: '/aide'
      fullPath: '/aide'
      preLoaderRoute: typeof AideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calcul-date-de-conception': {
      id: '/calcul-date-de-conception'
      path: '/calcul-date-de-conception'
      fullPath: '/calcul-date-de-conception'
      preLoaderRoute: typeof CalculDateDeConceptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calcul-ovulation': {
      id: '/calcul-ovulation'
      path: '/calcul-ovulation'
      fullPath: '/calcul-ovulation'
      preLoaderRoute: typeof CalculOvulationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calcul-semaines-amenorrhee': {
      id: '/calcul-semaines-amenorrhee'
      path: '/calcul-semaines-amenorrhee'
      fullPath: '/calcul-semaines-amenorrhee'
      preLoaderRoute: typeof CalculSemainesAmenorrheeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendrier-chinois-grossesse': {
      id: '/calendrier-chinois-grossesse'
      path: '/calendrier-chinois-grossesse'
      fullPath: '/calendrier-chinois-grossesse'
      preLoaderRoute: typeof CalendrierChinoisGrossesseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confidentialite': {
      id: '/confidentialite'
      path: '/confidentialite'
      fullPath: '/confidentialite'
      preLoaderRoute: typeof ConfidentialiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desabonnement': {
      id: '/desabonnement'
      path: '/desabonnement'
      fullPath: '/desabonnement'
      preLoaderRoute: typeof DesabonnementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/exemple': {
      id: '/exemple'
      path: '/exemple'
      fullPath: '/exemple'
      preLoaderRoute: typeof ExempleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grossesse-semaine-par-semaine': {
      id: '/grossesse-semaine-par-semaine'
      path: '/grossesse-semaine-par-semaine'
      fullPath: '/grossesse-semaine-par-semaine'
      preLoaderRoute: typeof GrossesseSemaineParSemaineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/idees-cadeaux': {
      id: '/idees-cadeaux'
      path: '/idees-cadeaux'
      fullPath: '/idees-cadeaux'
      preLoaderRoute: typeof IdeesCadeauxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liste-anniversaire': {
      id: '/liste-anniversaire'
      path: '/liste-anniversaire'
      fullPath: '/liste-anniversaire'
      preLoaderRoute: typeof ListeAnniversaireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liste-de-mariage': {
      id: '/liste-de-mariage'
      path: '/liste-de-mariage'
      fullPath: '/liste-de-mariage'
      preLoaderRoute: typeof ListeDeMariageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liste-de-naissance': {
      id: '/liste-de-naissance'
      path: '/liste-de-naissance'
      fullPath: '/liste-de-naissance'
      preLoaderRoute: typeof ListeDeNaissanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/liste-de-noel': {
      id: '/liste-de-noel'
      path: '/liste-de-noel'
      fullPath: '/liste-de-noel'
      preLoaderRoute: typeof ListeDeNoelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listes-en-groupe': {
      id: '/listes-en-groupe'
      path: '/listes-en-groupe'
      fullPath: '/listes-en-groupe'
      preLoaderRoute: typeof ListesEnGroupeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mentions-legales': {
      id: '/mentions-legales'
      path: '/mentions-legales'
      fullPath: '/mentions-legales'
      preLoaderRoute: typeof MentionsLegalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nouvelle-liste': {
      id: '/nouvelle-liste'
      path: '/nouvelle-liste'
      fullPath: '/nouvelle-liste'
      preLoaderRoute: typeof NouvelleListeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secret-santa': {
      id: '/secret-santa'
      path: '/secret-santa'
      fullPath: '/secret-santa'
      preLoaderRoute: typeof SecretSantaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tendances': {
      id: '/tendances'
      path: '/tendances'
      fullPath: '/tendances'
      preLoaderRoute: typeof TendancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mon-compte': {
      id: '/_authed/mon-compte'
      path: '/mon-compte'
      fullPath: '/mon-compte'
      preLoaderRoute: typeof AuthedMonCompteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calcul-date-accouchement/': {
      id: '/calcul-date-accouchement/'
      path: '/calcul-date-accouchement'
      fullPath: '/calcul-date-accouchement/'
      preLoaderRoute: typeof CalculDateAccouchementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calcul-date-accouchement/$method': {
      id: '/calcul-date-accouchement/$method'
      path: '/calcul-date-accouchement/$method'
      fullPath: '/calcul-date-accouchement/$method'
      preLoaderRoute: typeof CalculDateAccouchementMethodRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comparatif/': {
      id: '/comparatif/'
      path: '/comparatif'
      fullPath: '/comparatif/'
      preLoaderRoute: typeof ComparatifIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comparatif/$slug': {
      id: '/comparatif/$slug'
      path: '/comparatif/$slug'
      fullPath: '/comparatif/$slug'
      preLoaderRoute: typeof ComparatifSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/g/$slug': {
      id: '/g/$slug'
      path: '/g/$slug'
      fullPath: '/g/$slug'
      preLoaderRoute: typeof GSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/groupes/nouveau': {
      id: '/groupes/nouveau'
      path: '/groupes/nouveau'
      fullPath: '/groupes/nouveau'
      preLoaderRoute: typeof GroupesNouveauRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/idees-cadeaux-naissance/': {
      id: '/idees-cadeaux-naissance/'
      path: '/idees-cadeaux-naissance'
      fullPath: '/idees-cadeaux-naissance/'
      preLoaderRoute: typeof IdeesCadeauxNaissanceIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/idees-cadeaux-naissance/$category': {
      id: '/idees-cadeaux-naissance/$category'
      path: '/idees-cadeaux-naissance/$category'
      fullPath: '/idees-cadeaux-naissance/$category'
      preLoaderRoute: typeof IdeesCadeauxNaissanceCategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/list': {
      id: '/invitations/list'
      path: '/invitations/list'
      fullPath: '/invitations/list'
      preLoaderRoute: typeof InvitationsListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/l/$slug': {
      id: '/l/$slug'
      path: '/l/$slug'
      fullPath: '/l/$slug'
      preLoaderRoute: typeof LSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/verify': {
      id: '/login_/verify'
      path: '/login/verify'
      fullPath: '/login/verify'
      preLoaderRoute: typeof LoginVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/': {
      id: '/prenoms/'
      path: '/prenoms'
      fullPath: '/prenoms/'
      preLoaderRoute: typeof PrenomsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/$slug': {
      id: '/prenoms/$slug'
      path: '/prenoms/$slug'
      fullPath: '/prenoms/$slug'
      preLoaderRoute: typeof PrenomsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/tendances': {
      id: '/prenoms/tendances'
      path: '/prenoms/tendances'
      fullPath: '/prenoms/tendances'
      preLoaderRoute: typeof PrenomsTendancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/secret-santa_/nouveau': {
      id: '/secret-santa_/nouveau'
      path: '/secret-santa/nouveau'
      fullPath: '/secret-santa/nouveau'
      preLoaderRoute: typeof SecretSantaNouveauRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/conso': {
      id: '/_authed/admin/conso'
      path: '/conso'
      fullPath: '/admin/conso'
      preLoaderRoute: typeof AuthedAdminConsoRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/croissance': {
      id: '/_authed/admin/croissance'
      path: '/croissance'
      fullPath: '/admin/croissance'
      preLoaderRoute: typeof AuthedAdminCroissanceRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/designs': {
      id: '/_authed/admin/designs'
      path: '/designs'
      fullPath: '/admin/designs'
      preLoaderRoute: typeof AuthedAdminDesignsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/listes': {
      id: '/_authed/admin/listes'
      path: '/listes'
      fullPath: '/admin/listes'
      preLoaderRoute: typeof AuthedAdminListesRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/produits': {
      id: '/_authed/admin/produits'
      path: '/produits'
      fullPath: '/admin/produits'
      preLoaderRoute: typeof AuthedAdminProduitsRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/systeme': {
      id: '/_authed/admin/systeme'
      path: '/systeme'
      fullPath: '/admin/systeme'
      preLoaderRoute: typeof AuthedAdminSystemeRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/mes-groupes/$groupId': {
      id: '/_authed/mes-groupes/$groupId'
      path: '/mes-groupes/$groupId'
      fullPath: '/mes-groupes/$groupId'
      preLoaderRoute: typeof AuthedMesGroupesGroupIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mes-listes/': {
      id: '/_authed/mes-listes/'
      path: '/mes-listes'
      fullPath: '/mes-listes/'
      preLoaderRoute: typeof AuthedMesListesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mes-listes/$listId': {
      id: '/_authed/mes-listes/$listId'
      path: '/mes-listes/$listId'
      fullPath: '/mes-listes/$listId'
      preLoaderRoute: typeof AuthedMesListesListIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/mes-listes/$listId/preview': {
      id: '/mes-listes/$listId/preview'
      path: '/mes-listes/$listId/preview'
      fullPath: '/mes-listes/$listId/preview'
      preLoaderRoute: typeof MesListesListIdPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/annee/': {
      id: '/prenoms/annee/'
      path: '/prenoms/annee'
      fullPath: '/prenoms/annee/'
      preLoaderRoute: typeof PrenomsAnneeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/departement/': {
      id: '/prenoms/departement/'
      path: '/prenoms/departement'
      fullPath: '/prenoms/departement/'
      preLoaderRoute: typeof PrenomsDepartementIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/departement/$department': {
      id: '/prenoms/departement/$department'
      path: '/prenoms/departement/$department'
      fullPath: '/prenoms/departement/$department'
      preLoaderRoute: typeof PrenomsDepartementDepartmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/admin/sites/': {
      id: '/_authed/admin/sites/'
      path: '/sites'
      fullPath: '/admin/sites/'
      preLoaderRoute: typeof AuthedAdminSitesIndexRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/_authed/admin/sites/$host': {
      id: '/_authed/admin/sites/$host'
      path: '/sites/$host'
      fullPath: '/admin/sites/$host'
      preLoaderRoute: typeof AuthedAdminSitesHostRouteImport
      parentRoute: typeof AuthedAdminRoute
    }
    '/prenoms/annee/$year/': {
      id: '/prenoms/annee/$year/'
      path: '/prenoms/annee/$year'
      fullPath: '/prenoms/annee/$year/'
      preLoaderRoute: typeof PrenomsAnneeYearIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prenoms/annee/$year/$department': {
      id: '/prenoms/annee/$year/$department'
      path: '/prenoms/annee/$year/$department'
      fullPath: '/prenoms/annee/$year/$department'
      preLoaderRoute: typeof PrenomsAnneeYearDepartmentRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthedAdminRouteChildren {
  AuthedAdminConsoRoute: typeof AuthedAdminConsoRoute
  AuthedAdminCroissanceRoute: typeof AuthedAdminCroissanceRoute
  AuthedAdminDesignsRoute: typeof AuthedAdminDesignsRoute
  AuthedAdminListesRoute: typeof AuthedAdminListesRoute
  AuthedAdminProduitsRoute: typeof AuthedAdminProduitsRoute
  AuthedAdminSystemeRoute: typeof AuthedAdminSystemeRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedAdminSitesHostRoute: typeof AuthedAdminSitesHostRoute
  AuthedAdminSitesIndexRoute: typeof AuthedAdminSitesIndexRoute
}

const AuthedAdminRouteChildren: AuthedAdminRouteChildren = {
  AuthedAdminConsoRoute: AuthedAdminConsoRoute,
  AuthedAdminCroissanceRoute: AuthedAdminCroissanceRoute,
  AuthedAdminDesignsRoute: AuthedAdminDesignsRoute,
  AuthedAdminListesRoute: AuthedAdminListesRoute,
  AuthedAdminProduitsRoute: AuthedAdminProduitsRoute,
  AuthedAdminSystemeRoute: AuthedAdminSystemeRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedAdminSitesHostRoute: AuthedAdminSitesHostRoute,
  AuthedAdminSitesIndexRoute: AuthedAdminSitesIndexRoute,
}

const AuthedAdminRouteWithChildren = AuthedAdminRoute._addFileChildren(
  AuthedAdminRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRouteWithChildren
  AuthedMonCompteRoute: typeof AuthedMonCompteRoute
  AuthedMesGroupesGroupIdRoute: typeof AuthedMesGroupesGroupIdRoute
  AuthedMesListesListIdRoute: typeof AuthedMesListesListIdRoute
  AuthedMesListesIndexRoute: typeof AuthedMesListesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRouteWithChildren,
  AuthedMonCompteRoute: AuthedMonCompteRoute,
  AuthedMesGroupesGroupIdRoute: AuthedMesGroupesGroupIdRoute,
  AuthedMesListesListIdRoute: AuthedMesListesListIdRoute,
  AuthedMesListesIndexRoute: AuthedMesListesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  AideRoute: AideRoute,
  CalculDateDeConceptionRoute: CalculDateDeConceptionRoute,
  CalculOvulationRoute: CalculOvulationRoute,
  CalculSemainesAmenorrheeRoute: CalculSemainesAmenorrheeRoute,
  CalendrierChinoisGrossesseRoute: CalendrierChinoisGrossesseRoute,
  ConfidentialiteRoute: ConfidentialiteRoute,
  DesabonnementRoute: DesabonnementRoute,
  ExempleRoute: ExempleRoute,
  GrossesseSemaineParSemaineRoute: GrossesseSemaineParSemaineRoute,
  IdeesCadeauxRoute: IdeesCadeauxRoute,
  ListeAnniversaireRoute: ListeAnniversaireRoute,
  ListeDeMariageRoute: ListeDeMariageRoute,
  ListeDeNaissanceRoute: ListeDeNaissanceRoute,
  ListeDeNoelRoute: ListeDeNoelRoute,
  ListesEnGroupeRoute: ListesEnGroupeRoute,
  LoginRoute: LoginRoute,
  MentionsLegalesRoute: MentionsLegalesRoute,
  NouvelleListeRoute: NouvelleListeRoute,
  SecretSantaRoute: SecretSantaRoute,
  TendancesRoute: TendancesRoute,
  BlogSlugRoute: BlogSlugRoute,
  CalculDateAccouchementMethodRoute: CalculDateAccouchementMethodRoute,
  ComparatifSlugRoute: ComparatifSlugRoute,
  GSlugRoute: GSlugRoute,
  GroupesNouveauRoute: GroupesNouveauRoute,
  IdeesCadeauxNaissanceCategoryRoute: IdeesCadeauxNaissanceCategoryRoute,
  InvitationsListRoute: InvitationsListRoute,
  LSlugRoute: LSlugRoute,
  LoginVerifyRoute: LoginVerifyRoute,
  PSlugRoute: PSlugRoute,
  PrenomsSlugRoute: PrenomsSlugRoute,
  PrenomsTendancesRoute: PrenomsTendancesRoute,
  SecretSantaNouveauRoute: SecretSantaNouveauRoute,
  BlogIndexRoute: BlogIndexRoute,
  CalculDateAccouchementIndexRoute: CalculDateAccouchementIndexRoute,
  ComparatifIndexRoute: ComparatifIndexRoute,
  IdeesCadeauxNaissanceIndexRoute: IdeesCadeauxNaissanceIndexRoute,
  PrenomsIndexRoute: PrenomsIndexRoute,
  MesListesListIdPreviewRoute: MesListesListIdPreviewRoute,
  PrenomsDepartementDepartmentRoute: PrenomsDepartementDepartmentRoute,
  PrenomsAnneeIndexRoute: PrenomsAnneeIndexRoute,
  PrenomsDepartementIndexRoute: PrenomsDepartementIndexRoute,
  PrenomsAnneeYearDepartmentRoute: PrenomsAnneeYearDepartmentRoute,
  PrenomsAnneeYearIndexRoute: PrenomsAnneeYearIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
